<div *ngIf='dataLoading' class="dataLoading">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>

<div class="pdf-viewer-wrapper" [hidden]="dataLoading">
  <div class="toolbar" *ngIf="isConfig">
    <div class="container">
      <div class="d-flex align-items-center">
        <!-- <a [routerLink]="['/admin/meetings', meetingId]" class="btn btn-secondary py-2 mr-auto">{{'general.back' | translate}}</a> -->
        <button (click)="saveConfig()" class="btn btn-primary py-2 m-0"
          [class.loading]="loading == 'save'"
          [disabled]="loading">
          {{'group.save' | translate}}</button>

        <div class="ml-auto">
          @if(document) {
            <button (click)="closeDialog()" class="btn btn-secondary py-2"
              [disabled]="loading">{{'fields.Close' | translate}}</button>
          }
          <button (click)="saveConfig(true)" class="btn btn-danger py-2 ml-3 mr-0"
            [class.loading]="loading == 'reset'"
            [disabled]="loading">
            {{'general.Reset and Delete configuration' | translate}}</button>
        </div>
      </div>
    </div>
  </div>

  <div class="pdg-container" #pdfContainer></div>
</div>

<div class="modal fade" [class.show]="showUsersPopup" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
          <h4 class="modal-title"> {{ 'meetings.Choose member' | translate }} </h4>

          <button type="button" class="close" aria-label="Close" (click)="closeChooseUser()">
              <span>&times;</span>
          </button>
      </div>
      <div class="p-4">
        <input type="text" [(ngModel)]="searchUser"
          class="form-control" [placeholder]="'general.Search' | translate">
      </div>
      <div class="modal-body" style="max-height: 65vh;">
        <mat-radio-group [(ngModel)]="selectedUser">
          <div *ngFor="let option of optionsList" [hidden]="hideOption(option)">
            <mat-radio-button [value]="option" class="d-block py-2">
              <span [class.text-success]="isSelected(option)">
                {{option.fullName}} @if (option.collectionName) {({{option.collectionName}})}
              </span>
            </mat-radio-button>
          </div>
        </mat-radio-group>

        <div class="data-empty h-100" [hidden]="!isAllHidden()">
          <p class="m-0">{{"general.NoFound" | translate}}</p>
        </div>
      </div>

      <div class="modal-btns p-4">
          <button type="reset" class="close closebtn" aria-label="Close" (click)="closeChooseUser()">
            {{ 'swalMsg.cancel' | translate }}
          </button>
          <button mat-raised-button class="btn customBtn m-0"
            [disabled]="!selectedUser" (click)="selectChanged()">
            {{ 'entityCom.Add' | translate }}
          </button>
      </div>
  </div>
</div>
